export const LEAD_NAME_KEY = 'name'
export const LEAD_EMAIL_KEY = 'email'

export const EMAIL_ERROR_MESSAGE = 'Enter a valid email'
export const REQUIRED_ERROR_MESSAGE = 'This field is required'

export const COOKIE_KEY_EMAIL = 'prefill_email'
export const COOKIE_KEY_NAME = 'prefill_name'
export const COOKIE_KEY_ADDRESS = 'prefill_address'

export const LEAD_SUCCESS_CONTAINER_ID = 'lead_success_container'
export const GA_EVENT_CATEGORY = 'Contact Form'
export const GA_EVENT_SUBMITTED = 'Submitted'

export const API_POST_URL = '/leads/save/'

export const DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again'



// WEBPACK FOOTER //
// ./containers/LeadGen/constants.js